<template>
  <div>
    <div class="p-postEditor__externalLink">
      <v-card>
        <PreviewLayout :item="item" :loading="loading">
          <v-card-title class="subtitle-2">
            <a :href="url" rel="noopener noreferrer" target="_blank">
              <v-icon class="mr-1"> mdi-launch </v-icon>
              <span v-html="previewContent(sentence)"></span>
            </a>
          </v-card-title>
          <v-card-text>
            <p class="caption">
              {{ item.itemableAttributes.description }}
            </p>
          </v-card-text>
        </PreviewLayout>
      </v-card>
    </div>
  </div>
</template>

<script>
import PreviewLayout from './PreviewLayout'
import baseTextlintPreview from '@/mixins/base_textlint_preview'

export default {
  name: 'ExternalLinkItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    sentence: function () {
      return this.item.itemableAttributes.sentence
    },
    url: function () {
      return this.item.itemableAttributes.url
    }
  },
  mounted () {
    this.setLintAction(this.sentence)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.sentence)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  }
}
</script>
